export default function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-collection/src/values.js
// module id = esWz
// module chunks = 0